const MASKS_SIZE_OVERRIDE_STYLES = [
  862700, 895900, 855000, 885900, 839400, 986900, 987000
];

export default MASKS_SIZE_OVERRIDE_STYLES;
